import React, { useMemo, useCallback, useContext } from 'react';

// DEPENDENCIES
import { useParams } from 'react-router';
import { useFormikContext } from 'formik';
import { useDispatch } from 'react-redux';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';

// GLOBAL FUNCTIONS
import { makePath, modalFunctions, sleep } from 'functions.js';
import { recountActions } from 'actions.js';

// HELPERS
import { RecordContext } from 'helpers/getRecordData';

// GLOBAL COMPONENTS
import Button from 'core/tools/Button';
import Form from 'core/form/Form';

// MAIN COMPONENT
export default function RebillStatusLog() {
  const { values } = useFormikContext() || {};
  const { rebill_status_log } = useMemo(() => values || {}, [values]);
  const { refetchRecord } = useContext(RecordContext) || {};

  const dispatch = useDispatch();

  const { recordID } = useParams();

  const handleSuccess = useCallback(async () => {
    await sleep(2000);
    refetchRecord();
    dispatch(recountActions.toggle());
  }, [dispatch, refetchRecord]);

  const handleClick = useCallback(() => {
    modalFunctions.add({
      type: 'form',
      title: 'Request Rebill Correction',
      args: {
        method: 'PUT',
        endpoint: makePath(ENDPOINTS.sales.rebill, recordID),
        loadingMessage: 'Requesting Rebill Correction',
        successMessage: 'Request Rebill Correction Successfully.',
        errorMessage: 'Unable to Request Rebill Correction',
        onSuccess: handleSuccess
      },
      submitButton: {
        label: 'Confirm'
      },
      fields: (
        <Form.Col>
          Are you sure you want to request a Rebill correction for this deal? This will require the manager to correct
          the Accounting Invoice / Bill of Sale and E-Post this deal again.
        </Form.Col>,
        <Form.Textarea placeholder="Please enter your comment here" name="reactivate_epost_comment" required fullWidth />
      ),
      spacing: 'sm'
    });
  }, [handleSuccess, recordID]);

  return (
    <Form.Row>
      {rebill_status_log.map(({ date_adjusted, display_rebill_correction_button, rebill_by_user_full_name }, index) => (
        <Form.PlainText
          key={`Rebilled-${index}`}
          label={!index ? 'Rebilled' : ' '}
          value={
            <label className="text-gray-600">{`${date_adjusted}
            ${rebill_by_user_full_name ? `by ${rebill_by_user_full_name}` : ''}`}</label>
          }
          input={
            display_rebill_correction_button && {
              append: (
                <Button
                  label="Request Rebill Correction"
                  size="sm"
                  variant="secondary"
                  fullWidth={false}
                  onClick={handleClick}
                />
              )
            }
          }
        />
      ))}
    </Form.Row>
  );
}
